/** Persist as UTC ISO-8601. Render in the viewer's local timezone. */

export function nowIso(): string {
  return new Date().toISOString();
}

export function formatChatTimestamp(iso: string, now = new Date()): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";

  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfMsg = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const dayDiff = Math.round((startOfToday.getTime() - startOfMsg.getTime()) / 86_400_000);

  if (dayDiff === 0) return `Today at ${time}`;
  if (dayDiff === 1) return `Yesterday at ${time}`;

  const monthDay = d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  if (d.getFullYear() === now.getFullYear()) return `${monthDay} at ${time}`;
  return `${monthDay}, ${d.getFullYear()} at ${time}`;
}

export function sameCalendarDay(aIso: string, bIso: string): boolean {
  const a = new Date(aIso);
  const b = new Date(bIso);
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function jitter(min: number, max: number): number {
  return Math.floor(min + Math.random() * (max - min + 1));
}
